import _regeneratorRuntime from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
var defaultOptions = {
  timeout: 5000,
  jsonpCallback: 'callback',
  jsonpCallbackFunction: null
};

function generateCallbackFunction() {
  return "jsonp_".concat(Date.now(), "_").concat(Math.ceil(Math.random() * 100000));
}

function clearFunction(functionName) {
  // IE8 throws an exception when you try to delete a property on window
  // http://stackoverflow.com/a/1824228/751089
  try {
    delete window[functionName];
  } catch (e) {
    window[functionName] = undefined;
  }
}

function removeScript(scriptId) {
  var script = document.getElementById(scriptId);
  if (script) document.getElementsByTagName('head')[0].removeChild(script);
}

function fetchJsonp(_url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // to avoid param reassign
  var url = _url;
  var timeout = options.timeout || defaultOptions.timeout;
  var jsonpCallback = options.jsonpCallback || defaultOptions.jsonpCallback;
  var timeoutId;
  return new Promise(function (resolve, reject) {
    var callbackFunction = options.jsonpCallbackFunction || generateCallbackFunction();
    var scriptId = "".concat(jsonpCallback, "_").concat(callbackFunction);

    window[callbackFunction] = function (response) {
      resolve({
        ok: true,
        // keep consistent with fetch API
        json: function json() {
          return Promise.resolve(response);
        }
      });
      if (timeoutId) clearTimeout(timeoutId);
      removeScript(scriptId);
      clearFunction(callbackFunction);
    }; // Check if the user set their own params, and if not add a ? to start a list of params


    url += url.indexOf('?') === -1 ? '?' : '&';
    var jsonpScript = document.createElement('script');
    jsonpScript.setAttribute('src', "".concat(url).concat(jsonpCallback, "=").concat(callbackFunction));
    if (options.charset) jsonpScript.setAttribute('charset', options.charset);
    jsonpScript.id = scriptId;
    document.getElementsByTagName('head')[0].appendChild(jsonpScript);
    timeoutId = setTimeout(function () {
      reject(new Error("JSONP request to ".concat(_url, " timed out")));
      clearFunction(callbackFunction);
      removeScript(scriptId);

      window[callbackFunction] = function () {
        clearFunction(callbackFunction);
      };
    }, timeout); // Caught if got 404/500

    jsonpScript.onerror = function () {
      reject(new Error("JSONP request to ".concat(_url, " failed")));
      clearFunction(callbackFunction);
      removeScript(scriptId);
      if (timeoutId) clearTimeout(timeoutId);
    };
  });
}

export function inherit(C, P) {
  var F = function F() {};

  F.prototype = P.prototype;
  C.prototype = new F();
  var i, l, o;

  for (i = 2, l = arguments.length; i < l; i++) {
    o = arguments[i];
    if (typeof o === "function") o = o.prototype;
    extend(C.prototype, o);
  }
}
export function extend(destination, source) {
  destination = destination || {};

  if (source) {
    for (var property in source) {
      var value = source[property];
      if (value !== undefined) destination[property] = value;
    }

    if (source.hasOwnProperty && source.hasOwnProperty("toString")) destination.toString = source.toString;
  }

  return destination;
}
export function Class() {
  var len = arguments.length;
  var P = arguments[0];
  var F = arguments[len - 1];
  var C = typeof F.initialize == "function" ? F.initialize : function () {
    P.apply(this, arguments);
  };

  if (len > 1) {
    var newArgs = [C, P].concat(Array.prototype.slice.call(arguments).slice(1, len - 1), F);
    inherit.apply(null, newArgs);
  } else {
    C.prototype = F;
  }

  return C;
} // export const Events = Class({
//
//   _listeners: [],
//
//   initialize: function () {
//     this._listeners = [];
//   },
//
//   /**
//    * APIMethod: on Add an event listener
//    *
//    * Parameters: event - {String} Name of the event to listen to callback -
//    * {Function} Function to call when event fired
//    *
//    * Returns: listener - {object} Reference to the listener
//    */
//   on: function (event, callback) {
//     const listener = {event: event, callback: callback};
//     this._listeners.push(listener);
//     return listener;
//   },
//
//   /**
//    * APIMethod: off Remove an event listener
//    *
//    * Parameters: listener - {object} Reference to the listener returned by
//    * addListener
//    */
//   off: function (listener) {
//     for (let i = 0; i < this._listeners.length; i++) {
//       if (this._listeners[i] == listener) {
//         this._listeners.splice(i, 1);
//         break;
//       }
//     }
//   },
//
//   /**
//    * APIMethod: fireEvent Fire an event with a optional number of arguments
//    *
//    * Parameters: event - {String} Name of the event to listen to parameters -
//    * {Object} Optional object parsed to the listener
//    */
//   fireEvent: function (event) {
//     for (let i = 0; i < this._listeners.length; i++) {
//       if (this._listeners[i].event == event) {
//         if (typeof this._listeners[i].callback !== 'undefined') {
//           this._listeners[i].callback.apply(this, arguments);
//         }
//       }
//     }
//   }
// });

export function bind(func, object) {
  // create a reference to all arguments past the second one
  var args = Array.prototype.slice.apply(arguments, [2]);
  return function () {
    // Push on any additional arguments from the actual function call.
    // These will come after those sent to the bind call.
    var newArgs = args.concat(Array.prototype.slice.apply(arguments, [0]));
    return func.apply(object, newArgs);
  };
}
export function fetch2(_x) {
  return _fetch.apply(this, arguments);
}

function _fetch() {
  _fetch = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(url) {
    var options,
        response,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            options.headers = {};

            if (options.data) {
              if (options.method === 'post') {
                options.body = formData(options.data);
                options.headers = {
                  'Accept': 'application/json, application/xml, text/play, text/html, */*',
                  'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
                };
              } else {
                options.headers = {
                  'Accept': 'application/json'
                };
                url += (url.indexOf('?') === -1 ? '?' : '&') + queryParams(options.data);
              }

              delete options.data;
            }

            options.headers['Accept'] = 'application/json, application/xml, text/play, text/html, application/javascript, */*';
            options.crossDomain = true;
            _context.next = 7;
            return fetch(url, options);

          case 7:
            response = _context.sent;
            _context.next = 10;
            return response.json();

          case 10:
            return _context.abrupt("return", _context.sent);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetch.apply(this, arguments);
}

function formData(obj) {
  var formData = [];
  Object.keys(obj).forEach(function (key) {
    var name = encodeURIComponent(key);
    var value = encodeURIComponent(obj[key]);
    formData.push(name + '=' + value);
  });
  return formData.join('&');
}

export function fetch3(_x2) {
  return _fetch2.apply(this, arguments);
}

function _fetch2() {
  _fetch2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(url) {
    var options,
        response,
        _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};

            if (!(typeof window === 'undefined')) {
              _context2.next = 7;
              break;
            }

            _context2.next = 4;
            return fetch2(url, options);

          case 4:
            return _context2.abrupt("return", _context2.sent);

          case 7:
            if (options.data) {
              url += (url.indexOf('?') === -1 ? '?' : '&') + queryParams(options.data);
              delete options.data;
            }

            _context2.next = 10;
            return fetchJsonp(url, options);

          case 10:
            response = _context2.sent;
            _context2.next = 13;
            return response.json();

          case 13:
            return _context2.abrupt("return", _context2.sent);

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _fetch2.apply(this, arguments);
}

function queryParams(params) {
  return Object.keys(params).map(function (k) {
    return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]);
  }) //.map(k => k + '=' + params[k])
  .join('&');
}